<div class="flexLeftBaseline">

    <p class="headline6" *ngIf="personal">{{ 'profile.data.personal' | translate }}</p>
    <p class="headline6" *ngIf="bank">{{ 'profile.data.bank' | translate }}</p>
    <p class="headline6" *ngIf="contact">{{ 'profile.data.contact' | translate }}</p>
    <p class="headline6" *ngIf="physiological">{{ 'profile.data.physiological' | translate }}</p>
    <p class="headline6" *ngIf="background">{{ 'registration.stepThree.background' | translate}}</p>
    <p class="headline6" *ngIf="objetives">{{ 'registration.stepThree.objetives.title' | translate}}</p>
    <p class="headline6" *ngIf="achievements">{{ 'registration.stepThree.achievements' | translate}}</p>
    
    


    <button *ngIf="disable && showEdit" mat-button color="primary" class="editButton" (click)="edit()">
        <mat-icon>edit</mat-icon> {{'profile.data.edit' | translate }} 
    </button>
    <button *ngIf="!disable && !objetives && !achievements" [disabled]="!valid" mat-button color="primary" class="editButton" (click)="onSubmit()">
        <mat-icon *ngIf="!valid" class="greyIcon">save</mat-icon>
        <mat-icon *ngIf="valid">save</mat-icon>  
        {{'profile.data.save' |translate }}
    </button>
    <button *ngIf="!disable && objetives" [disabled]="!objetivesValid" mat-raised-button color="primary" class="editButton" (click)="onSubmit()">
        <mat-icon *ngIf="!objetivesValid" class="greyIcon">save</mat-icon>
        <mat-icon *ngIf="objetivesValid" class="whiteIcon">save</mat-icon> 
        {{'profile.data.save' | translate | uppercase}}
    </button>
    <button *ngIf="!disable && achievements" [disabled]="!achievementsValid" mat-raised-button color="primary" class="editButton" (click)="onSubmit()">
        <mat-icon *ngIf="!achievementsValid" class="greyIcon">save</mat-icon>
        <mat-icon *ngIf="achievementsValid" class="whiteIcon">save</mat-icon> 
        {{'profile.data.save' |translate | uppercase }}
    </button>
</div>
